// --- AppsFlyer GTM consent helpers ---
// TODO: AppsFlyer GTM is disabled until approved for production release.
// To re-enable, uncomment all function bodies below.
let appsFlyerSdkInitFired = false;
let nativeCuid: string | null = null;

// Queue for calls that arrive before consent + SDK init are ready
let pendingCuid: string | null = null;
const pendingEvents: {
  eventName: string;
  eventValues?: Record<string, any>;
}[] = [];

const NATIVE_APPSFLYER_STORAGE_KEY = "nativeAppsflyer";

/** Check if the app was launched from the native Android shell (via URL param) */
export const isNativeAndroidAppsflyer = (): boolean => {
  try {
    // Check sessionStorage first (persists across SPA navigations)
    const stored = sessionStorage.getItem(NATIVE_APPSFLYER_STORAGE_KEY);
    if (stored === "true") return true;

    // Check URL params (only present on initial launch)
    const params = new URLSearchParams(window.location.search);
    const value = params.get("nativeAppsflyer") === "true";
    if (value) {
      sessionStorage.setItem(NATIVE_APPSFLYER_STORAGE_KEY, "true");
    }
    return value;
  } catch {
    console.warn("Failed to parse URL parameters for nativeAppsflyer");
    return false;
  }
};

/** Check if a specific OneTrust consent group is active */
export const hasOneTrustConsent = (groupId: string): boolean => {
  const groups: string = (window as any).OptanonActiveGroups || "";
  return groups.indexOf(groupId) !== -1;
};

/** Check if both Performance (C0002) and Marketing (C0004) consent are granted */
export const hasAppsFlyerConsent = (): boolean => {
  return hasOneTrustConsent("C0002") && hasOneTrustConsent("C0004");
};

/** Push appsflyer_sdk_init to dataLayer (fires once, Android only) */
export const triggerAppsFlyerSdkInit = (): void => {
  // TODO: Disabled — uncomment when AppsFlyer is approved for prod release.
  // console.log("Triggering AppsFlyer SDK init via GTM event");
  // if (appsFlyerSdkInitFired) return;
  // const devKey = import.meta.env.VITE_APPSFLYER_WEB_DEV_KEY;
  // if (!devKey) { console.warn("VITE_APPSFLYER_WEB_DEV_KEY is not set"); return; }
  // appsFlyerSdkInitFired = true;
  // window?.dataLayer?.push?.({ event: "appsflyer_sdk_init", appsflyerWebDevKey: devKey });
  // if (pendingCuid) { pushAppsFlyerCuid(pendingCuid); pendingCuid = null; }
  // pendingEvents.splice(0).forEach(({ eventName, eventValues }) => { pushAppsFlyerGtmEvent(eventName, eventValues); });
};

/** Send CUID to native Android via deep link (Android only) */
const sendCuidToNativeAndroid = (_cuid: string): void => {
  // TODO: Disabled — uncomment when AppsFlyer is approved for prod release.
  // const intentUrl =
  //   `intent://set-customer-id?customerId=${encodeURIComponent(_cuid)}` +
  //   `#Intent;scheme=canesmeno;package=com.bayer.ch.canesmenohub;S.browser_fallback_url=;end`;
  // const iframe = document.createElement("iframe");
  // iframe.style.display = "none";
  // iframe.src = intentUrl;
  // document.body.appendChild(iframe);
  // setTimeout(() => { try { document.body.removeChild(iframe); } catch { /* already removed */ } }, 200);
};

/** Push appsflyer_set_cuid to dataLayer and send to native Android (Android only) */
export const pushAppsFlyerCuid = (_cuid: string): void => {
  // TODO: Disabled — uncomment when AppsFlyer is approved for prod release.
  // if (!_cuid) return;
  // if (!hasAppsFlyerConsent() || !appsFlyerSdkInitFired) { pendingCuid = _cuid; return; }
  // nativeCuid = _cuid;
  // window?.dataLayer?.push?.({ event: "appsflyer_set_cuid", appsflyer_cuid: _cuid });
  // sendCuidToNativeAndroid(_cuid);
};

/** Push appsflyer_event to dataLayer (Android only) */
export const pushAppsFlyerGtmEvent = (
  _eventName: string,
  _eventValues?: Record<string, any>,
): void => {
  // TODO: Disabled — uncomment when AppsFlyer is approved for prod release.
  // if (!hasAppsFlyerConsent() || !appsFlyerSdkInitFired) {
  //   pendingEvents.push({ eventName: _eventName, eventValues: _eventValues });
  //   return;
  // }
  // window?.dataLayer?.push?.({
  //   event: "appsflyer_event",
  //   appsflyer_event_name: _eventName,
  //   appsflyer_event_values: _eventValues || {},
  // });
  // if (nativeCuid) sendCuidToNativeAndroid(nativeCuid);
};
